import App from './components/App';
import { h, render } from 'preact';
import * as firebase from './firebase';
import store from './store';

const IS_DEV_ENV = process && process.env && process.env.NODE_ENV !== 'production';
const el = document.getElementById('app');

store.subscribe('user', state => {
  const user = state.user;

  if (!user) {
    return;
  }

  // Fetch all user stuffs
});

if (IS_DEV_ENV) {
  window.IncludeCart = {
    firebase,
    store,
  };
}

render(<App />, el);
